<div *ngIf="practices$ | async as practices" class="flex flex-col gap-2">
  <button
    *ngFor="let practice of practices; trackBy: trackByPractice"
    class="w-full"
    mat-stroked-button
    (click)="loadPractice(practice)"
  >
    {{ practice.name }}
  </button>
</div>
